import { keys, toString } from 'ramda';
import { Store } from './abstract-storage';

export class Session extends Store {
  constructor() {
    super();
  }

  override setItem(name: string, value: any, params = {}) {
    window.sessionStorage.setItem(name, toString(value));
    return value;
  }

  override getItem(name: string) {
    return JSON.parse(window.sessionStorage.getItem(name) as string);
  }

  override deleteItem(name: string) {
    window.sessionStorage.removeItem(name);
  }

  override clear() {
    window.sessionStorage.clear();
  }

  override length() {
    return window.sessionStorage.length;
  }

  override keys() {
    return keys(window.sessionStorage);
  }
}
